export const signUpSmartSearchSelectorName = 'signUpSmartSearch';
